import { Component, HostListener, ElementRef, OnInit, ViewChild, Renderer2, } from '@angular/core';
import { AlertController, IonContent, LoadingController, Platform } from '@ionic/angular';
import { GetDataService } from 'src/providers/get-data.service';
import { PostDataService } from 'src/providers/post-data.service';
import { Router } from '@angular/router';
import { IonLoaderService } from 'src/providers/ion-loader.service';
import { DomSanitizer } from '@angular/platform-browser';
import { CookieService } from 'ngx-cookie-service';
import { environment } from 'src/environments/environment';
import { SeoService } from 'src/providers/seo.service';
import { TranslateService } from '@ngx-translate/core';
import { NgForm } from '@angular/forms';
import * as CryptoJS from 'crypto-js';
import { HttpErrorResponse } from '@angular/common/http';
import { param } from 'jquery';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  @ViewChild('content', { read: IonContent }) content!: IonContent;
  dataLoaded: boolean = false;
  imageUrl = environment.image_Url;
  languageId: any;
  languageArray: any[] = [];
  langId: any = environment.Eng;
  arkLogo: any = '';
  deckproLogo: any = '';
  isMenuOpen = false;
  isMobileView = false;
  formData: any = {
    email: '',
    password: ''
  }
  errorMessage: any;
  successMassage: any = "";
  loginFlag: boolean = false;
  userData: any;
  representative: any = '';

  forgotEmail: string = '';
  resetErrorMessage: string = '';
  resetSuccessMessage: string = '';


  constructor(
    private platform: Platform,
    private getData: GetDataService,
    private postData: PostDataService,
    private renderer: Renderer2,
    private el: ElementRef,
    private router: Router,
    private loader: IonLoaderService,
    public sanitizer: DomSanitizer,
    private cookieService: CookieService,
    private SEO_services: SeoService,
    private translate: TranslateService,
    private readonly loadingController: LoadingController,
    private readonly alertController: AlertController,
  ) { }

  ngOnInit() {
    this.loader.simpleLoader();
    this.languageId = localStorage.getItem('LanguageID');
    this.langId = this.languageId;
    const storedFlag = localStorage.getItem('loginFlag');
    this.loginFlag = storedFlag === 'true';
    const storedUser = localStorage.getItem('userData');
    this.userData = storedUser ? JSON.parse(storedUser) : null;
    this.checkMobileView();
    this.loadLanguage();
    if (this.loginFlag) {
      this.fatchRepresentativeDetails();
    }
    this.loader.dismissLoader();
  }

  async fatchRepresentativeDetails() {
    try {
      const res: any = await this.postData.postRepresentativeDetails();
      // console.log(res);

      if (res.statusCode == 200) {
        this.representative = res?.data;
      }
    } catch (error) {
      console.error('Representative Details API Error: ', error);
    }
  }

  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event?: Event) {
    this.checkMobileView();
  }

  private checkMobileView() {
    this.isMobileView = window.innerWidth <= 992;
  }

  loadLanguage() {
    this.getData.getHomelanguageData().then(async (res: any) => {
      if (res) {
        this.languageArray = res?.data;
      } else {
        this.dataLoaded = true;
      }
    });
    this.getSiteSetting();
  }

  getSiteSetting() {
    this.getData.getHeader(this.languageId).then(async (res: any) => {
      if (res) {
        this.arkLogo = res?.data[0]?.arkLogo;
        this.deckproLogo = res?.data[0]?.deckproLogo;
      }
    });
  }

  onLanguageChange() {
    localStorage.setItem('LanguageID', this.langId);
    window.location.reload();
  }

  async onSubmit(form: NgForm) {
    if (form.valid) {
      this.errorMessage = null;
      const loading = await this.loadingController.create({
        message: 'Loading...',
        cssClass: 'loader-css-class',
      });
      await loading.present();
      const payload = {
        email: this.formData.email,
        password: this.formData.password,
        issuedAt: Date.now()
      };
      const encrypted = this.encryptLoginPayload(payload);
      const param = {
        loginParameter: encrypted
      }
      // console.log("Form Submitted", payload);
      try {
        const res: any = await this.postData.postUserLogin(param);
        if (res?.statusCode === 200) {
          const token = res?.data?.token;
          // const token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6NjMsInVzZXJOYW1lIjoiZWFzaHdhcjU2ODJAZ21haWwuY29tIiwiZW1haWwiOiJlYXNod2FyNTY4MkBnbWFpbC5jb20iLCJmaXJzdE5hbWUiOiJFYXNod2FyIiwibGFzdE5hbWUiOiJJeWVyIiwicGhvbmUiOiJlYXNod2FyNTY4MkBnbWFpbC5jb20iLCJzdXBwbGllcklkIjoxNCwic3VwcGxpZXJBZ2VudElkIjo0MTkyLCJhZ2VudENvbnRhY3RJZCI6Mzg3MiwiY291bnRyeSI6IkluZGlhICjgpK3gpL7gpLDgpKQpIiwiY291bnRyeUNvZGUiOiI5MSIsImlhdCI6MTc1MjEzNzAxNCwiZXhwIjoxNzUyMTM3MDc0fQ.BrPtE14imOGrUN5TkbRCh9WYnibYKKQQ4ikh7hGIi1Y";
          const refreshToken = res?.data?.refreshToken;
          if (token && token !== 'null' && token !== '') {
            localStorage.setItem('loginToken', JSON.stringify(token));
            localStorage.setItem('refreshToken', JSON.stringify(refreshToken));
            localStorage.setItem('loginFlag', 'true');

            if (res?.data?.userData) {
              localStorage.setItem('userData', JSON.stringify(res?.data?.userData));
            }
            this.successMassage = res?.message;
            this.errorMessage = null;
          } else {
            // token missing or invalid
            this.errorMessage = 'Login token not received. Please try again.';
            localStorage.setItem('loginFlag', 'false');
            return;
          }
          form.resetForm();
          location.reload();
        }
        else {
          localStorage.setItem('loginFlag', 'false');
          const message = res?.message;
          if (Array.isArray(message)) {
            this.errorMessage = message[0];
          } else if (typeof message === 'string') {
            this.errorMessage = message;
          } else {
            this.errorMessage = 'An unknown error occurred.';
          }
        }
      } catch (err) {
        console.log(err);
        localStorage.setItem('loginFlag', 'false');
        this.errorMessage = 'Something went wrong. Please try again.';
      } finally {
        await loading.dismiss();
      }
    } else {
      console.warn("Form invalid");
    }
  }


  encryptLoginPayload(payload: any): string {
    const jsonData = JSON.stringify(payload);
    const encrypted = CryptoJS.AES.encrypt(jsonData, environment.CRYPTO_SECRET_KEY).toString();
    return encrypted;
  }

  logout() {
    // Clear login-related data
    localStorage.removeItem('loginToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('userData');
    // localStorage.clear();
    localStorage.setItem('loginFlag', 'false');

    // Optional: Reset variables
    this.loginFlag = false;
    this.userData = null;

    // Optional: Navigate to login page
    this.router.navigate(['/home']).then(() => {
      // Reload the whole app after routing completes
      location.reload();
    });
  }


  async resetPassword(form: NgForm) {
    this.resetSuccessMessage = '';
    this.resetErrorMessage = '';
    if (form.valid) {
      const payload = {
        email: this.forgotEmail
      }
      try {
        const res: any = await this.postData.postForgetPassword(payload);
        if (res.statusCode == 200) {
          this.resetSuccessMessage = res?.message;
          form.resetForm();
        } else {
          this.resetErrorMessage = res?.message;
        }
      } catch (err) {
        console.log(err);
      } finally {
        await this.loader.dismissLoader();
      }
    }
  }


}


// http://localhost:8100/reset-password/3mexLsJL4L72QtHkeb5TJgZ4jEbSHw1753426088013